import { createSelector } from '@app/utils/createSelector'
import { catchFetchDataError } from '@app/utils/performFetchData'

import type { ApiPersonnelCheckType } from '@app/packages/api/v2/types/entities'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

const personnelCheckTypesSlice = createReduxSlice<ApiPersonnelCheckType[]>('personnel_check_types')

export const fetchPersonnelCheckTypes = () =>
  createThunk(async dispatch => {
    const [{ getPersonnelChecksTypes }, { callV2Api }] = await Promise.all([
      import('@app/packages/api/v2/actions/personnel_checks'),
      import('@app/store/actions/api'),
    ])
    const resp = await dispatch(callV2Api(getPersonnelChecksTypes())).catch(catchFetchDataError(dispatch, 'Personnel check types fetch failed'))
    dispatch(personnelCheckTypesSlice.set(resp.data))
  })

export const personnelCheckTypesListSelector = createSelector([personnelCheckTypesSlice.selector], list => list ?? [])
